; (function ($) {

    $('.Loading').fadeOut('slow')

})(jQuery);
